import { Component, OnInit, HostListener, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';
import { SessionService } from 'src/app/core/auth/session.service';
import { ApiService } from 'src/app/core/http/api.service';
import { Utilities } from 'src/app/core/tools/utilities';

@Component({
  selector: 'app-config-layout',
  templateUrl: './config-layout.component.html',
  styleUrls: ['./config-layout.component.css'],
})
export class ConfigurationLayoutComponent implements OnInit {
  public isVerificationSelected: boolean = false;
  public selectedOption = 1;
  public screenWidth: number = 0;
  vertical = true;
  incomplete: boolean = false;
  isDisabled: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private router: Router,
    private auth: AuthService
  ) {
    const incomplete = this.route.snapshot.queryParamMap.get('incomplete');
    if (incomplete) {
      this.incomplete = true;
      this.getOperatorConfigByOperatorId();
    }
  }

  ngOnInit(): void {
    if (this.auth.isAgent()) {
      this.selectOption(2);
    } else {
      this.selectOption(1);
    }
    this.responsiveScreen();
    const token = this.auth.getToken();
    if (!token) {
      this.router.navigate(['/']);
    }
  }

  isDataSavedReceived = (e: any) => {
    if (e) {
      this.getOperatorConfigByOperatorId();
    }
  };

  getOperatorConfig = (operatorId?: string) => {
    this.apiService.GetOperatorConfig(/*operatorId*/).subscribe((response) => {
      const {
        timeZoneCatId,
        languageCatId,
        logoUrl,
        casinoName,
        logoCasinoUrl,
        // contactEmail,
        // countryCodeId,
        // contactPhone,
        // mesaggingServices,
        timeZoneCasinoCatId,
        languageCasinoCatId,
      } = response.data;
      let requeredConfigData = {
        operator: {
          timeZoneCatId,
          languageCatId,
          logoUrl,
        },
        casino: {
          casinoName,
          logoCasinoUrl,
          // contactEmail,
          // countryCodeId,
          // contactPhone,
          // mesaggingServices,
          timeZoneCasinoCatId,
          languageCasinoCatId,
        },
      };
      //requeredConfigData.casino.casinoName = null;
      let operator = Utilities.hasNull(requeredConfigData.operator);
      let casino = Utilities.hasNull(requeredConfigData.casino);
      if (operator || casino) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    });
  };

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.responsiveScreen();
  }

  selectOption(val: number) {
    this.selectedOption = val;
  }

  closeConfigLayout() {
    // this.isGeneralSelected = false;
    // this.isCreditsSelected = false;
    // this.isVerificationSelected = false;
    // navigate out of the config layout
  }

  responsiveScreen() {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth < 768) {
      this.vertical = false;
    } else {
      this.vertical = true;
    }
  }

  goToHome = () => {
    this.router.navigate(['/']);
  };

  getOperatorConfigByOperatorId = () => {
    this.apiService.getOperatorId(this.auth.getToken()).subscribe({
      next: (res) => {
        this.getOperatorConfig(/*res.data.operatorId*/);
      },
    });
  };

  isAgent() {
    return this.auth.isAgent();
  }
}
